var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'violation-toggler__delete-answer': true,
        'violation-toggler__delete-answer_open': _vm.isDelete,
    },on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"delete-answer"},[_c('ViolationDeleteAnswerOk',{on:{"click":function($event){$event.stopPropagation();return _vm.deleteViolation.apply(null, arguments)}}}),_c('ViolationDeleteAnswerCancel',{on:{"click":function($event){$event.stopPropagation();return _vm.togglerDeleteViolation.apply(null, arguments)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }